export const validDomainPattern = new RegExp('^(?!\\-)(?:[a-zA-Z\\d\\-]{0,62}[a-zA-Z\\d]\\.){1,126}(?!\\d+)[a-zA-Z\\d-]{1,63}$');

/**
 * Checks if the passed domain is valid.
 *
 * @since 0.1.24
 *
 * @param {String} domain The domain to check.
 *
 * @returns {boolean} Whether domain is valid.
 */
export const isValidDomain = domain => {
	return domain
		.trim()
		// Remove http/s
		.replace(new RegExp('^http(s?)://'), '')
		// Remove www
		.replace(new RegExp('^www.'), '')
		// Remove //
		// eslint-disable-next-line no-useless-escape
		.replace(new RegExp('^\/\/'), '')
		.match(validDomainPattern);
};

